import { useTranslation } from 'next-i18next';
import React from 'react';
import { useFeatureToggle } from '@hotelplan/libs.feature-toggle';
import { FdrBookmarkObjectType } from '@hotelplan/supergraph-api';
import {
  BookmarkComponentType,
  trackOpenEditBookmarkPopup,
} from 'components/domain/tracking/bookmarkTracking';
import { FeatureList } from 'config/featureList';
import {
  BookmarkModalPopupType,
  useBookmarkModalPopupContext,
} from './context/fdr-bookmark-modal-popup-context';
import FdrBookmarkEditIcon from './fdr-bookmark-edit-icon';
import FdrSingularBookmarkGroupBlock from './fdr-bookmark-singular-group-block';

interface IBookmarkBlockProps {
  pageType: FdrBookmarkObjectType;
  objectId: string;
  bookmarkId: string;
  groupId: string;
}

const BookmarkEditBlock: React.FC<IBookmarkBlockProps> = ({
  pageType,
  objectId,
  bookmarkId,
  groupId,
}) => {
  const { isEnabled } = useFeatureToggle();
  const multipleBookmarksEnabled = isEnabled(FeatureList.MULTIPLE_BOOKMARKS);
  const bookmarkModalPopupContext = useBookmarkModalPopupContext();
  const [, { language }] = useTranslation();

  return (
    <>
      {!multipleBookmarksEnabled && (
        <FdrSingularBookmarkGroupBlock
          pageType={pageType}
          objectId={objectId}
          trackingComponent={BookmarkComponentType.BOOKMARK_PAGE}
          active
        />
      )}
      {multipleBookmarksEnabled && (
        <FdrBookmarkEditIcon
          onClick={() => {
            trackOpenEditBookmarkPopup(language);
            bookmarkModalPopupContext.open({
              type: BookmarkModalPopupType.EDIT_BOOKMARK,
              payload: {
                pageType,
                bookmarkId,
                objectId,
                groupId,
              },
            });
          }}
        />
      )}
    </>
  );
};
export default BookmarkEditBlock;
